document.addEventListener('DOMContentLoaded', function() {
  // Fix Cart, Account, Wishlist toolbar items
  document.querySelectorAll(
    '.hdt-toolbart-cart .hdt-toolbar-item-btn, ' +
    '.hdt-toolbart-account .hdt-toolbar-item-btn, ' +
    'hdt-wishlist-a .hdt-toolbar-item-btn'
  ).forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href && href !== '#') {
        window.location.href = href;
      }
    });
  });
});
